import React, { useContext, useEffect } from 'react'
import { contextData } from '../../App'
import UpcomingEvents from '../../components/UpcomingEvents/UpcomingEvents';

function EventPage() {
  const {isScrolled, setIsScrolled} = useContext(contextData);
  useEffect(() => {
    window.scrollTo(0, 0);
    setIsScrolled(true)
    return () => { setIsScrolled(false) }
  }, [])
  return (
    <div className='pt-[114px]'>
      <UpcomingEvents/>
    </div>
  )
}

export default EventPage
